//todo
// toggle Edit button

import React, { Component } from 'react';
import {connect} from 'react-redux';
import { Form, Field} from 'react-final-form';
import { CardForm } from '../../widgets/Cards';
import { editPatient } from '../../../actions';
import formatString from "format-string-by-pattern";


class PatientDetail extends Component {

    formButton() {
        var permit = this.props.selectedPermission.permission[0].general;
        if (permit === "View only") {
            return "inaction";
        } else { 
            return "action";
        }  
    }
  
    patientDetailForm() { 
        const content = this.props.content;

        const handleSubmit = (formValues) => {
            const form = formValues;
            this.props.editPatient(form, form._id);
        }

        const required = value =>(value ? undefined : 'Required');
      
        return (
            <Form
                onSubmit = {handleSubmit}
                initialValues = {content}
                render = {({handleSubmit, pristine, form, values, submitting}) => {
                    return (
                        <form onSubmit={handleSubmit}>
                            <div className='header'>Patient Detail</div>

                            <div className='form-container'>
                            <Field name="title" component='input'>
                                {({ input}) => (
                                    <div>
                                        <label>Title</label>
                                        <select {...input}>
                                            <option value="Mr">Mr</option>
                                            <option value="Mrs">Mrs</option>
                                            <option value="Ms">Ms</option>
                                            <option value='Dr'>Dr</option>
                                            <option value='Mx'>Mx</option>
                                            <option value='Prof'>Prof</option>
                                            <option value='A/P'>A/P</option>
                                        </select>
                                    </div>
                              )}
                            </Field>
                            <Field name='nickname' component='input' validate={required} placeholder=''>
                                {({input, meta, placeholder}) => (
                                    <div className={meta.active ? 'active':''}>
                                        <label>Nick Name</label>
                                        <input {...input} placeholder={placeholder} />
                                        {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                    </div>
                                )} 
                            </Field>
                            <Field name='firstname' component='input' validate={required} placeholder=''>
                                {({input, meta, placeholder}) => (
                                    <div className={meta.active ? 'active':''}>
                                        <label>First Name</label>
                                        <input {...input} placeholder={placeholder} />
                                        {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                    </div>
                                )} 
                            </Field>
                            <Field name='middlename' component='input' validate={required} placeholder=''>
                                {({input, meta, placeholder}) => (
                                    <div className={meta.active ? 'active':''}>
                                        <label>Middle Name</label>
                                        <input {...input} placeholder={placeholder} />
                                        {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                    </div>
                                )} 
                            </Field>
                            <Field name='lastname' component='input' validate={required} placeholder=''>
                                {({input, meta, placeholder}) => (
                                    <div className={meta.active ? 'active':''}>
                                        <label>Last Name</label>
                                        <input {...input} placeholder={placeholder} />
                                        {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                    </div>
                                )} 
                            </Field>
                            <Field name="dob" component='input' label="Date of Birth" validate={required}>
                                {({input, meta}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Date of Birth</label>
                                            <input {...input} type='date' />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                            </Field>
                            
                            <Field name="gender" component='input'>
                                {({ input}) => (
                                    <div>
                                        <label>Gender</label>
                                        <select {...input}>
                                            <option value="Male">Male</option>
                                            <option value="Female">Female</option>
                                            <option value="Transgender">Transgender</option>
                                            <option value="Non-binary">Non-binary</option>
                                        </select>
                                    </div>
                              )}
                            </Field>
                            <Field name="aborigin" component='input'>
                                {({ input}) => (
                                    <div>
                                        <label>ATSI status</label>
                                        <select {...input}>
                                            <option value="Non-ATSI">Non-ATSI</option>
                                            <option value="Aboriginal">Aborigin</option>
                                            <option value="Torres Strait Islander">Torres Strait Islander</option>
                                        </select>
                                    </div>
                              )}
                            </Field>
                          
                            <Field name='address1' component='input' validate={required} placeholder=''>
                                {({input, meta, placeholder}) => (
                                    <div style={{ gridColumn : 'span 2'}} className={meta.active ? 'active':''}>
                                        <label>Address Line 1</label>
                                        <input {...input} placeholder={placeholder} />
                                        {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                    </div>
                                )} 
                            </Field>
                        
                            <Field name='address2' component='input' validate={required} placeholder=''>
                                {({input, meta, placeholder}) => (
                                    <div style={{ gridColumn : 'span 2'}} className={meta.active ? 'active':''}>
                                        <label>Address Line 2</label>
                                        <input {...input} placeholder={placeholder} />
                                        {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                    </div>
                                )} 
                            </Field>
                            <Field name='suburb' component='input' validate={required} placeholder=''>
                                {({input, meta, placeholder}) => (
                                    <div className={meta.active ? 'active':''}>
                                        <label>Suburb</label>
                                        <input {...input} placeholder={placeholder} />
                                        {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                    </div>
                                )} 
                            </Field>
                            <Field name="state" component='input'>
                                {({ input}) => (
                                    <div>
                                        <label>State</label>
                                        <select {...input}>
                                            <option value="NSW">NSW</option>
                                            <option value="VIC">VIC</option>
                                            <option value="QLD">QLD</option>
                                            <option value='NT'>NT</option>
                                            <option value='TAS'>TAS</option>
                                            <option value='WA'>WA</option>
                                        </select>
                                    </div>
                              )}
                            </Field>
                            <Field name='postcode' component='input'  parse={formatString('0000')}  validate={required} placeholder='xxxx'>
                                {({input, meta}) => (
                                    <div className={meta.active ? 'active':''}>
                                        <label>Postcode</label>
                                        <input {...input} type='number' maxlength='4' placeholder='xxxx' />
                                        {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                    </div>
                                )} 
                            </Field>
                            <Field name='phone' component='input'  parse={formatString('(000)-0000-0000')} validate={required} placeholder='(000)-0000-0000'>
                                {({input, meta, placeholder}) => (
                                    <div className={meta.active ? 'active':''}>
                                        <label>Phone Number</label> 
                                        <input {...input} placeholder={placeholder} />
                                        {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                    </div>
                                )} 
                            </Field>
                            <Field name='mobile' component='input' parse={formatString('(+61)-0400-000-000')} validate={required} placeholder=''>
                                {({input, meta, placeholder}) => (
                                    <div className={meta.active ? 'active':''}>
                                        <label>Mobile Number</label>
                                        <input {...input} placeholder={placeholder} />
                                        {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                    </div>
                                )} 
                            </Field>
                            <Field name='email' component='input' validate={required} placeholder=''>
                                {({input, meta, placeholder}) => (
                                    <div className={meta.active ? 'active':''}>
                                        <label>Email Address </label>
                                        <input {...input} placeholder={placeholder} />
                                        {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                    </div>
                                )} 
                            </Field>
                            <div></div>
                            <div></div>
                            <Field name='medicare' component='input' validate={required} placeholder=''>
                                {({input, meta, placeholder}) => (
                                    <div className={meta.active ? 'active':''}>
                                        <label>Medicare Number</label>
                                        <input {...input} placeholder={placeholder} />
                                        {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                    </div>
                                )} 
                            </Field>
                            <Field name='dva' component='input' validate={required} placeholder=''>
                                {({input, meta, placeholder}) => (
                                    <div className={meta.active ? 'active':''}>
                                        <label>DVA Number</label>
                                        <input {...input} placeholder={placeholder} />
                                        {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                    </div>
                                )} 
                            </Field>
                            <Field name='hpi' component='input' validate={required} placeholder=''>
                                {({input, meta, placeholder}) => (
                                    <div className={meta.active ? 'active':''}>
                                        <label>HPI-I</label>
                                        <input {...input} placeholder={placeholder} />
                                        {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                    </div>
                                )} 
                            </Field>
                            <Field name='meta[0].practiceID' component='input' validate={required} placeholder=''>
                                {({input, meta, placeholder}) => (
                                    <div className={meta.active ? 'active':''}>
                                        <label>Record Number</label>
                                        <input {...input} placeholder={placeholder} />
                                        {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                    </div>
                                )} 
                            </Field>
                            </div>

                            <div className={this.formButton()}>
                                <button type='submit' disabled={submitting || pristine} className='btnew'>Submit</button>
                                <button type='button' onClick={form.reset} disabled={submitting || pristine } className='btdel'>Reset</button>
                                <button onClick={() => this.setState({showModal: false, record: null})} className='btdel'>Cancel</button>
                            </div>
                        </form>
                    )
                }}
            />
        )
    }

    render() {
        return (
            <CardForm content={this.patientDetailForm()}>
            </CardForm>
        )
    }
}


const mapStateToProps = (state) => {
    return { 
        content : state.selectedPatient,
        selectedPermission : state.selectedPermission,
    };
}

export default connect(mapStateToProps,{editPatient})(PatientDetail);